<template>
  <svg
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 0a2 2 0 0 0-2 2v26c0 1.1.9 2 2 2h26a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm6.17 21.03h2.93v-8.8H8.17v8.8Zm1.44-10h.02c1.02 0 1.66-.67 1.66-1.51C11.27 8.66 10.65 8 9.65 8 8.65 8 8 8.66 8 9.52c0 .84.63 1.52 1.61 1.52Zm9.1 10h2.92V16c0-2.7-1.44-3.96-3.36-3.96a2.9 2.9 0 0 0-2.64 1.45v-1.24h-2.92c.04.82 0 8.8 0 8.8h2.92v-4.92a2 2 0 0 1 .1-.71c.21-.53.7-1.07 1.5-1.07 1.06 0 1.48.8 1.48 1.99v4.7Z"
      fill="currentColor"
    />
  </svg>
</template>
